module.exports = __webpack_public_path__ + "assets/img/iOS_Dark.bc925be4.svg";